import type { ReactNode } from "react";

/** The shared white-panel container used by every guide tab. */
export function Card({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <section className="mb-3 rounded-xl bg-white p-4 shadow-sm">
      {title && <h2 className="mb-2 text-sm font-semibold text-gray-900">{title}</h2>}
      {children}
    </section>
  );
}
